﻿import {ValidationMessage} from '../validationMessage';
import {ValidationMessageType} from '../validationMessageType';
import {IncorrectFormat, ValueTooLong, ValueTooShort} from '../validationConstants';
import {ValidateResult} from '../validateResult';
import {IValidator} from './iValidator';

export enum NumericValidatorType {
    Decimal,
    Int,
    PositiveInt
}

var MaxInt = 999999999;
var MinInt = -999999999;
  
export class NumericValidator implements IValidator {
    validate(value: string, propertyName: string, propertydisplayName: string, errorMessage:string, type: NumericValidatorType): ValidateResult {
        let result= new ValidateResult();
        if (!value)
            return result;
        if(type && (type === NumericValidatorType.Int || type === NumericValidatorType.PositiveInt))
            return this.validateInt(value, propertyName, type === NumericValidatorType.PositiveInt, errorMessage);
        if (!parseFloat(value))
            result.validationMessage = this.createMessage(IncorrectFormat, IncorrectFormat, propertyName, errorMessage);
        return result;
    }

    private validateInt(value, propertyName: string, isPositiveInt: boolean, errorMessage:string): ValidateResult {
        let result = new ValidateResult();
        let x = parseFloat(value);
        if (!isNaN(value)) {
            if (x > MaxInt)
                result.validationMessage = this.createMessage(IncorrectFormat, ValueTooLong, propertyName, errorMessage);
            else if ((isPositiveInt && value<0) || (!isPositiveInt && value < MinInt))
                result.validationMessage = this.createMessage(IncorrectFormat, ValueTooShort, propertyName, errorMessage);
        }
        else
            result.validationMessage = this.createMessage(IncorrectFormat, IncorrectFormat, propertyName, errorMessage);
        return result;
    }

    private createMessage(highLevelMessage, message, propertyName, errorMessage):ValidationMessage {
        let vm = new ValidationMessage();
//        if (typeof errorMessage == 'undefined' || errorMessage == null || errorMessage == '') {
            vm.message = message;
  //      } else {
    //        vm.message = errorMessage;
      //  }
        
        vm.propertyName = propertyName;
        vm.messageType = ValidationMessageType.Error;
        return vm;
    }

}